<template>
  <div>
    <BaseListPage
        id="orderListTable"
        ref="listPage"
        :function-key="functionKey"
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :show-selection="showSelection"
        :no-search="noSearch"
        :row-key="rowKey"
        :min-column-width="'200px'"
        :is-max-get-count="isMaxGetCount"
        :async-render="true"
        title="注文一覧"
        title-class="order-header"
        icon="order"
        :table-class="tableClass"
        @dataConvert="dataConvert"
        @row-click="onRowClick">
      <span
          slot="message"
          class="headerMessage">
        注文修正禁止時間帯：10:00-10:15、22:00-22:15
      </span>
      <span
          v-show="mode === ACTION_MODE.NORMAL"
          slot="headerAction"
          class="action_button">
        <el-dropdown @command="actionCommand">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                v-if="$isFunctionShown(define.PermissionKeys.Order.List.MAIL)"
                :disabled="disableMailButton"
                :command="ACTION_MODE.MAIL">
              メール
            </el-dropdown-item>
            <el-dropdown-item :command="ACTION_MODE.SEARCH">
              検索条件設定
            </el-dropdown-item>
            <el-dropdown-item :command="ACTION_MODE.DISPLAY">
              表示項目設定
            </el-dropdown-item>
            <ToDownload
                page-key="order_list"
                :conditions="conditions"
                :keyword="searchKeyword"
                :is-and-search="isAndSearch" />
          </el-dropdown-menu>
        </el-dropdown>
      </span>
      <span
          v-show="mode !== ACTION_MODE.NORMAL"
          slot="headerActionMode"
          class="action_button">
        <el-button size="small"
            @click="cancel">
          キャンセル
        </el-button>
        <el-button
            v-show="mode === ACTION_MODE.MAIL"
            :disabled="selectQty === 0"
            size="small"
            @click="sendMail">
          送信
        </el-button>
      </span>
      <template
          slot="tableOperation"
          slot-scope="{ row }">
        <BaseOperationTooltip
            v-if="showTooltip"
            :list="getTooltipList(row.row)"
            class="operation-button"
            placement="bottom-end" />
      </template>
      <template
          slot="prefixTable">
        <div class="prefixTableRow">
          <el-button size="small"
              @click="clickDisplaySelect">
            表示項目
          </el-button>
          <el-button size="small"
              @click="clickDisplaySave">
            表示項目保存
          </el-button>
        </div>
        <div v-show="mode === ACTION_MODE.MAIL"
            class="prefixTableRow">
          <span>
            {{
              `メール種類： ${((mailTemplate || []).find((template) => template.uuid === selectedMailTemplate) || {}).templateName || ''}`
            }}
          </span>
          <span>
            {{
              `対象注文件数： ${selectQty} 件`
            }}
          </span>
        </div>
      </template>
    </BaseListPage>
    <BaseDialog
        title="メールテンプレート選択"
        width="35%"
        class="mailTemplateDialog"
        :show-only-close-button="false"
        :visible.sync="mailTemplateDialogVisible"
        @closed="mailTemplateDialogCancelClose"
        @cancel="mailTemplateDialogCancelClose"
        @ok="mailTemplateDialogOK">
      <template slot="contents">
        <div class="mailTemplateContents">
          <span>
            テンプレート名
          </span>
          <el-select
              v-model="selectedMailTemplate"
              v-validate="'required'"
              data-vv-scope="template"
              name="template"
              data-vv-name="テンプレート">
            <el-option
                v-for="option in mailTemplate"
                :key="option.uuid"
                :label="option.templateName"
                :value="option.uuid" />
          </el-select>
          <span v-if="errors.has('template')">
            {{ errors.first('template') }}
          </span>
        </div>
      </template>
    </BaseDialog>

    <!-- O-Pluxイベント更新 -->
    <OpluxDialog
        :oplux-data="opluxData"
        :visible.sync="isOpluxDialog" />

    <!-- 検索条件設定 -->
    <BaseSearchConditionListModal
        function-key="order_list"
        :store-path="storePath"
        :visible.sync="isSearchConditionListDialog" />

    <!-- 表示項目設定 -->
    <BaseDisplayListModal
        function-key="order_list"
        :display-config="displayItems"
        :store-path="storePath"
        :visible.sync="isDisplayListDialog" />
    <!-- 表示項目 -->
    <BaseDisplaySelectModal
        function-key="order_list"
        :table-set-list="_tableSetList"
        :display-config="displayItems"
        :store-path="storePath"
        :visible.sync="isDisplaySelectDialog" />
    <!-- 表示項目保存 -->
    <BaseDisplaySaveModal
        function-key="order_list"
        :display-config="displayItems"
        :visible.sync="isDisplaySaveDialog" />
  </div>
</template>

<style scoped>
.headerMessage {
  color: red;
}

.prefixTableRow .el-button {
  text-align: center;
  margin-bottom: 10px;
}
.prefixTableRow .el-button >>> span {
  margin: 0px;
}

.mailTemplateDialog .mailTemplateContents {
  padding: 10px;
  display: flex;
  color: #9da6ba;
  font-weight: bold;
}

.mailTemplateDialog .mailTemplateContents span {
  width: 150px;
  display: flex;
  align-items: center;
}

.mailTemplateDialog .mailTemplateContents .el-select {
  width: 100%;
}

#orderListTable >>> .el-table__header .qty .cell {
  white-space: pre-line!important;
}

#orderListTable >>> .el-table__row .itemHtml {
  padding: 0!important;

}
#orderListTable >>> .el-table__row .itemHtml > .cell {
  padding: 0!important;
}
#orderListTable >>> table {
  border-collapse:collapse
}

#orderListTable >>> tr {
  border-bottom: solid 1px #dddddd;
}

#orderListTable >>> .innerItem:not(th) {
  padding: 0px!important;
  border-left: solid 1px #dddddd;
  border-right: solid 1px #dddddd;
}
#orderListTable >>> .innerItem .cell {
  padding: 0px!important;
}

#orderListTable >>> .el-table__row .innerTable {
  width: 100%;
  table-layout: fixed;
}

#orderListTable >>> .el-table__row .innerTable tr {
  background-color: initial;
}

#orderListTable >>> .el-table__row .innerTable tr:last-child {
  border-bottom: none;
}

#orderListTable >>> .el-table__row .innerTable td {
  padding-left: 10px;
  padding-right: 10px;
}

#orderListTable >>> .el-table__row .innerTable .tag .el-tag {
  min-width: 48%;
  text-align: center;
}

</style>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as config from '@/config'
import * as define from '@/define'
import * as query from '@/queries/order'
import * as mailQuery from '@/queries/mail'
import common from '@/utils/common'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import BaseDialog from '@/components/molecules/BaseDialog'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'

import BaseDisplayListModal from '@/components/organisms/BaseDisplayListModal'
import BaseDisplaySaveModal from '@/components/organisms/BaseDisplaySaveModal'
import BaseDisplaySelectModal from '@/components/organisms/BaseDisplaySelectModal'

import BaseSearchConditionListModal from '@/components/organisms/BaseSearchConditionListModal'
import ToDownload from '@/components/organisms/ToDownload'
import OpluxDialog from '@/components/pages/order/OpluxDialog'

/**
 * 注文一覧画面 アクションモード
 */
export const ACTION_MODE = Object.freeze(
  {
    NORMAL: 0,         // 通常
    MAIL: 1,           // メール送信
    SEARCH: 2,         // 検索条件
    DISPLAY: 3         // 表示項目
  }
)

export default {
  name: 'OrderList',
  components: {
    BaseListPage,
    BaseDialog,
    BaseOperationTooltip,
    BaseDisplayListModal,
    BaseDisplaySaveModal,
    BaseDisplaySelectModal,
    BaseSearchConditionListModal,
    ToDownload,
    OpluxDialog
  },
  mixins: [ x, orderUtil, confirmDiscardOnLeave ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      showSelection: false,
      mode: ACTION_MODE.NORMAL,
      mailTemplate: [],
      mailTemplateDialogVisible: false,
      selectedMailTemplate: '',
      isOpluxDialog: false,
      opluxData: {},
      isDisplayListDialog: false,
      isDisplaySelectDialog: false,
      isDisplaySaveDialog: false,
      isSearchConditionListDialog: false
    }
  },
  computed: {
    define: () => define,
    ACTION_MODE: () => ACTION_MODE,
    ...mapState({
      tableSetList: (state) => state.Order.tableSetList || false,
      searchKeyword: (state) => state.Order.searchKeyword || '',
      tdLists: (state) => state.Order.tdLists || [],
      isAndSearch: (state) => state.Order.isAndSearch || false,
      conditions: (state) => state.Order.searchConditions || {},
      timeZone: (state) => state.timeZone || 'Asia/Tokyo',
      displayItems: (state) => state.Order.displayItems
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    functionKey () {
      return 'order_list'
    },
    name () {
      return 'orderList'
    },
    storePath () {
      return 'Order'
    },
    saveKey () {
      return 'orderCondition'
    },
    responsePath () {
      return 'data.latestOrders.edges'
    },
    linkKey () {
      return ['node.site.code', 'node.orderNo']
    },
    returnPath () {
      return '/order'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_ORDER_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    noSearch () {
      return this.mode !== ACTION_MODE.NORMAL
    },
    rowKey () {
      return 'node.id'
    },
    selectQty () {
      return this.mode === ACTION_MODE.NORMAL ? 0
        : _.get(this.$refs, 'listPage.$refs.tableList.$refs.table.selection.length', 0)
    },
    tableClass () {
      return `orderlist-table-list ${this.mode === ACTION_MODE.NORMAL ? 'row-clickable-table' : ''}`
    },
    _tableSetList () {
      const returnValue = [
        {
          itemKey: 'orderNo', isAvailable: false, isActive: false,
          type: 'String', label: '注文番号', path: 'node.orderNo', sortable: 'custom', funcId: define.PermissionKeys.Order.List.ORDER_NUMBER
        },
        {
          itemKey: 'shipmentId', isAvailable: false, isActive: false,
          type: 'String', label: '配送番号',
          path: (row) => this.getHtmlShipmentUnit(row, 'shipmentId'),
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.SHIPMENT_ID, class: 'innerItem'
        },
        {
          itemKey: 'leadtime', isAvailable: false, isActive: false,
          type: 'String', label: 'リードタイム', path: (row) => {
            let str = ''
            row.node.shipments.map(x => {
              str += x.leadtime + '\n'
            })
            return str
          }, lineBreak: true, elementType: ELEMENT_TYPE.FUNCTION, colsep: `
        `, sortable: true, sortBy: (row) => {
            return Math.max(...row.node.shipments.map(x => { return x.leadtime }))
          }, funcId: define.PermissionKeys.Order.List.LEAD_TIME
        },
        {
          itemKey: 'site', isAvailable: false, isActive: false,
          type: 'String', label: 'サイト', path: ['node.site.code', 'node.site.name'], colsep: ': ',
          sortable: 'custom', name: 'node.site.code', funcId: define.PermissionKeys.Order.List.SITE
        },
        {
          itemKey: 'orderDatetime', isAvailable: false, isActive: false,
          type: 'Date', label: '注文日時', path: 'node.orderDatetime', sortable: 'custom', funcId: define.PermissionKeys.Order.List.ORDER_DATETIME
        },
        {
          itemKey: 'name', isAvailable: false, isActive: false,
          type: 'String', label: '注文者名', sortable: true, sortBy: (row) => {
            return row.node.orderer.lastName + ' ' + row.node.orderer.firstName
          },
          path: ['node.orderer.lastName', 'node.orderer.firstName'], colsep: ' ',
          funcId: define.PermissionKeys.Order.List.ORDERER_NAME
        },
        {
          itemKey: 'nameKana', isAvailable: false, isActive: false,
          type: 'String', label: '注文者名カナ', sortable: true, sortBy: (row) => {
            return row.node.orderer.lastNameKana + ' ' + row.node.orderer.firstNameKana
          },
          path: ['node.orderer.lastNameKana', 'node.orderer.firstNameKana'], colsep: ' ',
          funcId: define.PermissionKeys.Order.List.ORDERER_NAME_KANA
        },
        {
          itemKey: 'price', isAvailable: false, isActive: false,
          type: 'String', label: '購入金額',
          path: this.grossPrice, class: 'right', sortable: true, sortBy: (row) => {
            return Number(row.node.orderTotalPrice.gross)
          },
          elementType: ELEMENT_TYPE.FUNCTION,
          funcId: define.PermissionKeys.Order.List.PURCHASE_AMOUNT
        },
        {
          itemKey: 'paymentStatus', isAvailable: false, isActive: false,
          type: 'String', label: '支払ステータス', path: 'node.isPaid', codeName: 'd_order.is_paid',
          class: 'center', sortable: 'custom', funcId: define.PermissionKeys.Order.List.IS_PAID
        },
        {
          itemKey: 'paymentMethod', isAvailable: false, isActive: false,
          type: 'String', label: '支払方法', path: this.paymentMethod, elementType: ELEMENT_TYPE.TAG,
          class: 'center payment-method-tag', size: 'small', width: '270px', funcId: define.PermissionKeys.Order.List.PAYMENT_METHOD
        },
        {
          itemKey: 'orderStatus', isAvailable: false, isActive: false,
          type: 'String', label: '注文ステータス', path: this.orderStatus, elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag', size: 'small', width: '250px', funcId: define.PermissionKeys.Order.List.ORDER_STATUS
        },
        { width: '1px' }, // 配送単位、商品単位の表示項目の切替のため
        {
          itemKey: 'postalCode', isAvailable: false, isActive: false,
          type: 'String', label: '郵便番号',
          path: (row) => this.getHtmlShipmentUnit(row, 'address.postalCode'),
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.POSTAL_CODE, class: 'innerItem',
          width: '100px'
        },
        {
          itemKey: 'stateCode', isAvailable: false, isActive: false,
          type: 'String', label: '都道府県',
          path: (row) => this.getHtmlShipmentUnit(row, 'address.stateCode'),
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.STATE, class: 'innerItem',
          width: '100px'
        },
        {
          itemKey: 'city', isAvailable: false, isActive: false,
          type: 'String', label: '市区町村',
          path: (row) => this.getHtmlShipmentUnit(row, 'address.city'),
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.CITY, class: 'innerItem',
          width: '140px'
        },
        {
          itemKey: 'address1', isAvailable: false, isActive: false,
          type: 'String', label: '住所1',
          path: (row) => this.getHtmlShipmentUnit(row, 'address.address1'),
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.ADDRESS_1, class: 'innerItem',
          width: '250px'
        },
        {
          itemKey: 'address2', isAvailable: false, isActive: false,
          type: 'String', label: '住所2',
          elementType: ELEMENT_TYPE.HTML_FUNCTION,
          path: (row) => this.getHtmlShipmentUnit(row, 'address.address2'),
          funcId: define.PermissionKeys.Order.List.ADDRESS_2, class: 'innerItem',
          width: '250px'
        },
        {
          itemKey: 'lineitemText', isAvailable: false, isActive: false,
          type: 'String', label: '商品',
          path: (row) => this.getHtmlProductUnit(row, 'lineitemText'),
          isProductUnit: true, elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.PRODUCT_NAME, class: 'innerItem',
          width: '400px'
        },
        {
          itemKey: 'qty', isAvailable: false, isActive: false,
          type: 'String', label: '数量',
          path: (row) => this.getHtmlProductUnit(row, 'qty.current', true),
          isProductUnit: true, elementType: ELEMENT_TYPE.HTML_FUNCTION,
          funcId: define.PermissionKeys.Order.List.PRODUCT_QTY, class: 'innerItem',
          width: '50px'
        },
        {
          itemKey: 'orderNotes', isAvailable: false, isActive: false,
          type: 'String', label: 'メモ', path: this.orderNotes, elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag', size: 'small', width: '250px', funcId: define.PermissionKeys.Order.List.ORDER_NOTES
        },
        {
          itemKey: 'redResult', isAvailable: false, isActive: false,
          type: 'String', label: '不正検知審査結果', path: 'node.redResult', codeName: 'd_order.red_result', colsep: `
        `, lineBreak: true, funcId: define.PermissionKeys.Order.List.RED_RESULT
        },
        {
          itemKey: 'operation', isAvailable: true, isActive: true, fixed: 'right',
          type: 'Slot', label: '', path: 'operation', width: '60px', columnKey: 'operation', class: 'right',
          isShow: () => this.$isFunctionShown(define.PermissionKeys.Order.List.ORDER_NUMBER) || this.$isFunctionShown(define.PermissionKeys.Order.List.SHIPMENT_ID) ||
          this.$isFunctionShown(define.PermissionKeys.Order.List.SITE) || this.$isFunctionShown(define.PermissionKeys.Order.List.ORDER_DATETIME) ||
          this.$isFunctionShown(define.PermissionKeys.Order.List.IS_PAID) || this.$isFunctionShown(define.PermissionKeys.Order.List.PAYMENT_METHOD) ||
          this.$isFunctionShown(define.PermissionKeys.Order.List.ORDER_STATUS) || this.$isFunctionShown(define.PermissionKeys.Order.List.ORDER_NOTES) ||
          this.$isFunctionShown(define.PermissionKeys.Order.List.LEAD_TIME)
        }
      ]

      // 属性情報の追加
      for (const displayItem of (this.displayItems || []).filter((data) => data.isAttribute)) {
        returnValue.push(
          {
            itemKey: displayItem.itemKey, elementType: ELEMENT_TYPE.FUNCTION,
            type: 'String', label: displayItem.attributeDisplayName,
            path: (row) => {
              const attribute = _.get(row, `node.attributes`, [])
              const returnValue = attribute.find((data) => data.attrId === displayItem.attributeProperty)
              return (returnValue || {}).attrValue || ''
            },
            isAvailable: true, isActive: displayItem.isDisplay,
            displayOrder: displayItem.displayOrder
          }
        )
      }

      for (const displayItem of (this.displayItems || []).filter((data) => !data.isAttribute)) {
        const item = returnValue.find((data) => data.itemKey === displayItem.itemKey)
        if (item) {
          _.set(item, 'isAvailable', true)
          _.set(item, 'isActive', displayItem.isDisplay)
          _.set(item, 'displayOrder', displayItem.displayOrder)
        }
      }

      return returnValue.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    showTooltip () {
      return this.mode === ACTION_MODE.NORMAL
    },

    /** メール送信アクション */
    disableMailButton () {
      // 実行権限なし、又は一覧の件数が 0 以下の場合は非活性
      return this.$isFunctionDisabled(define.PermissionKeys.Order.List.MAIL) || this.sortedList.length <= 0
    },
    showProductUnit () {
      return this._tableSetList.some((item) => item.isProductUnit && item.isActive && item.isAvailable)
    },
    isMaxGetCount () {
      return this.$isFunctionShown(define.PermissionKeys.Order.List.MAX_GET_COUNT)
    }
  },
  watch: {
    displayItems: {
      handler: function (val) {
        this.$store.dispatch({
          type: 'set',
          states: {
            'Order/tableSetList': this._tableSetList
          }
        })
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // テンプレート情報取得
      await this.getMailTemplateData()

      // 設定tableSetListの情報取得
      const work = await common.getDisplayItems('order_list')

      this.$store.dispatch({
        type: 'set',
        states: {
          'Order/displayItems': work
        }
      })

      this.$store.dispatch({
        type: 'set',
        states: {
          'Order/tableSetList': this._tableSetList
        }
      })

    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  onBeforeEnter (event) {
    this.$_tableRowAnimator_cancelAnimation = true
  },
  onBeforeUnload (event) {
    this.$_tableRowAnimator_cancelAnimation = false
  },
  methods: {
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case ACTION_MODE.MAIL:
          this.mailTemplateDialogVisible = true
          break
        case ACTION_MODE.SEARCH:
          // 検索条件設定ダイアログ表示
          this.isSearchConditionListDialog = true
          break
        case ACTION_MODE.DISPLAY:
          // 表示項目設定ダイアログ表示
          this.isDisplayListDialog = true
          break
      }
    },
    /**
     * 注文ステータスを返却します。
     * @param {Object} row 注文情報
     * @returns {Array} tag 生成のための配列
     */
    orderStatus: function (row) {
      return this.$_orderUtil_headerOrderStatusTag(row.node)
    },
    /**
     * 指定された最新注文IDの注文記録情報を取得します
     * @param {Object} row 注文情報
     * @returns {String} tag
     */
    orderNotes: function (row) {
      let orderPaymentTag = []
      if (row.node.notes.length > 0) {
        orderPaymentTag.push({ label: 'あり', class: 'tag-green-light-1', type: 'info' })
      } else {
        orderPaymentTag.push({ label: 'なし', type: 'info' })
      }
      return orderPaymentTag
    },
    /**
     * 支払方法を返却します。
     * @param {Object} 注文情報
     * @returns {Array} tag 生成のための配列
     */
    paymentMethod: function (row) {
      return this.$_orderUtil_orderPaymentTag(row.node.payments)
    },
    /**
     * 購入金額を返却します。
     * @param {Object} 注文情報
     * @returns {Array} tag 生成のための配列
     */
    grossPrice: function (row) {
      return common.concatCurrency(row.node.orderTotalPrice.gross, row.node.currency)
    },
    /**
     * Tooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (row) {
      return [
        {
          title: '注文修正',
          disabled: () => this.disableEditOrderButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.EDIT),
          click: (item) => this.operationButton(row, define.ORDER_MODE.EDIT),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.EDIT)
        }, {
          title: '再送',
          disabled: () => this.disableShortageButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.SHORTAGE),
          click: (item) => this.operationButton(row, define.ORDER_MODE.SHORTAGE),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.SHORTAGE)
        }, {
          title: '交換出荷',
          disabled: () => this.disableExchangeButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.EXCHANGE),
          click: (item) => this.operationButton(row, define.ORDER_MODE.EXCHANGE),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.EXCHANGE)
        }, {
          title: '返品登録',
          disabled: () => this.disableReceivedRegisterButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.RECEIVED),
          click: (item) => this.operationButton(row, define.ORDER_MODE.RECEIVED),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.RECEIVED)
        }, {
          title: '手動決済',
          disabled: () => this.disableCaptureButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.CAPTURE),
          click: (item) => this.operationButton(row, define.ORDER_MODE.CAPTURE),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.CAPTURE)
        }, {
          title: '一括取消',
          disabled: () => this.disableOrderCancelButton(row) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.CANCEL),
          click: (item) => this.operationButton(row, define.ORDER_MODE.CANCEL),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.CANCEL)
        }, {
          title: 'O-Plux',
          click: (item) => this.onOpluxClick(row),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.OPLUX) &&
            this.isEableOplux(row)
        }
      ]
    },
    /**
     * 注文修正ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableEditOrderButton: function (row) {
      return !this.$_orderUtil_isEditableByQty(this.getItems(row))
    },
    /**
     * 再送ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableShortageButton: function (row) {
      return !this.$_orderUtil_isShortageShippableByQty(this.getItems(row))
    },
    /**
     * 交換ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableExchangeButton: function (row) {
      return !this.$_orderUtil_isExchangeableByQty(this.getItems(row))
    },
    /**
     * 返品ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableReceivedRegisterButton: function (row) {
      return !this.$_orderUtil_isReceivedFixableByQty(this.getItems(row))
    },
    /**
     * 手動決済ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableCaptureButton: function (row) {
      return !this.$_orderUtil_isCapturable(row.node.payments, row.node.paymentSets)
    },
    /**
     * 一括取消ボタン
     * @param {Object} row 注文情報
     * @return {Boolean}
     */
    disableOrderCancelButton: function (row) {
      return !this.$_orderUtil_isCancellableByQty(this.getItems(row))
    },
    /**
     * O-PLUXボタン
     * @param {Object} row 注文情報
     * @return {Boolean} イベントIDが存在する場合は true
     */
    isEableOplux: function (row) {
      const redEventId = _.keyBy((row.node || []).attributes, 'attrId').redEventId
      return redEventId || false
    },
    /**
     * オペレーションボタンクリック
     * リンククリックコール、store の更新、注文詳細への遷移を行います。
     * @param {Object} row 注文情報
     * @param {Number} mode 注文詳細画面モード
     */
    operationButton: function (row, mode) {
      // 修正NGの状態がないかチェック
      if (this.$_orderUtil_showOrderExportInProcessDialogIfNeed(row.node) ||
          this.$_orderUtil_showUneditableOrderPaymentDialogIfNeed(row.node)) {
        return
      }

      this.$_mixin_onLinkClick(this.findIndex(row), this.storePath, mode)
      this.$store.dispatch({
        type: 'set',
        states: {
          'Order/returnList': true
        }
      })
      this.$router.push({ path: 'order/' + this.$_mixin_getData(row, this.linkKey, '&') })
    },
    /**
     * O-Pluxボタンクリック
     */
    onOpluxClick (row) {
      // 行データをセット
      this.opluxData = _.pick(row, ['node.uuid', 'node.lastUpdatedAt', 'node.redResult', 'node.attributes'])
      // モーダル表示
      this.isOpluxDialog = true
    },
    onRowClick (row, column, event) {
      if ((column || {}).columnKey === 'operation' ||
        this.mode !== ACTION_MODE.NORMAL) {
        // tooltipのセルクリック時は何もしない
        // モードが通常以外は何もしない
        return
      }

      const id = this.$_mixin_getData(row, this.linkKey, '&')
      const index = this.findIndex(row)
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/order/${id}` })
    },
    findIndex (row) {
      let condition = _.chain(this.linkKey)
        .reduce((acc, cur) => {
          acc[cur] = _.get(row, cur)
          return acc
        }, {})
        .value()
      return this.$_mixin_findIndex(this.sortedList, condition)
    },
    getItems (row) {
      return _.chain(row)
        .get('node.shipments')
        .flatMap(val => val.items)
        .value()
    },
    dataConvert (result) {
      // 不要なattributeは除去する
      const needAttribute = (this.displayItems || [])
        .filter((data) => data.isAttribute)
        .map((data) => data.attributeProperty)

      result.forEach((data) => {
        _.set(data, 'node.attributes',
          _.get(data, 'node.attributes', []).filter((data) => {
            return needAttribute.includes(data.attrId) || data.attrId.startsWith('red')
          }))
      })
    },
    /**
     * キャンセルボタン
     */
    cancel: async function () {
      switch (this.mode) {
        case ACTION_MODE.MAIL:
          this.showSelection = false
          const tableData = _.get(this.$refs, 'listPage.$refs.tableList.$refs.table', {})
          tableData.clearSelection()
          break
      }
      this.mode = ACTION_MODE.NORMAL
      this.$_ConfirmDiscardOnLeave_watchEnd()
    },
    /**
     * 送信ボタン
     */
    sendMail: async function (mode) {
      // メール送信APIの呼び出し
      this.$confirm('メールを送信しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // メール送信API呼び出し
          const url = config.MAIL_NOTIFY
          const method = 'post'
          await common.apiAxios(url, {
            method,
            data: {
              templateUuid: this.selectedMailTemplate,
              records:
                _.get(this.$refs, 'listPage.$refs.tableList.$refs.table.selection', []).map((row) => {
                  return {
                    order: {
                      uuid: row.node.uuid
                    }
                  }
                })
            }
          })

          this.$notify.success('送信処理を行いました。')
          this.$_ConfirmDiscardOnLeave_watchEnd()
          this.showSelection = false
          this.mode = ACTION_MODE.NORMAL
          const tableData = _.get(this.$refs, 'listPage.$refs.tableList.$refs.table', {})
          tableData.clearSelection()
        } catch (error) {
          common.addError(error, { msg: message.MSG_539() })
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    mailTemplateDialogCancelClose: async function () {
      this.mailTemplateDialogVisible = false
    },
    mailTemplateDialogOK: async function () {
      if (!await this.$validator.validate()) {
        return
      }

      this.$_ConfirmDiscardOnLeave_watchStart(this.mode, 'メール送信を中止しますか？')
      this.showSelection = true
      this.mode = ACTION_MODE.MAIL
      this.mailTemplateDialogVisible = false
    },
    async getMailTemplateData () {
      let param = common.addGraphQlCondition(mailQuery.GRAPH_QL_QUERY_MAIL_TEMPLATE_SIMPLE,
        { types: 99 })
      const res = await common.postGraphQl(param)
      this.mailTemplate = (common.getValueByPath(res.data, 'data.mailTemplates.edges') || [])
        .map((template) => { return { uuid: template.node.uuid, templateName: template.node.templateName } })
      this.selectedMailTemplate = (this.mailTemplate[0] || {}).uuid || ''
    },
    clickDisplaySave () {
      this.isDisplaySaveDialog = true
    },
    clickDisplaySelect () {
      this.isDisplaySelectDialog = true
    },
    // 表に出力する対象パスの表示用htmlの返却（配送単位のもの）
    getHtmlShipmentUnit (row, path, isNumber = false) {
      let htmlStr = ` <table class='innerTable'> `
      const shipments = _.get(row, 'node.shipments', [])
      for (const shipment of shipments) {
        let value = _.get(shipment, path, '')
        if (isNumber) {
          value = Number(value)
        }
        const rowSpan = this.showProductUnit ? (shipment.items || ['']).length : 1

        htmlStr += `
            <tr>
              <td>
                <div style='height:${rowSpan * 53 - 25}px;width:100%;text-overflow: ellipsis;overflow-x: hidden; white-space: nowrap;' ${isNumber ? ` class='right'` : ''}>${value}</div>
              </td>
            </tr>
        `
      }
      htmlStr += ' </table> '
      return htmlStr
    },
    // 表に出力する対象パスの表示用htmlの返却（商品単位のもの）
    getHtmlProductUnit (row, path, isNumber = false) {
      let htmlStr = ` <table class='innerTable'> `
      const shipments = _.get(row, 'node.shipments', [])
      for (const shipment of shipments) {
        for (const item of shipment.items) {
          let value = _.get(item, path, '')
          if (isNumber) {
            value = Number(value)
          }
          htmlStr += `
              <tr>
                <td>
                  <div style='width:100%;height:28px;text-overflow: ellipsis;overflow-x: hidden; white-space: nowrap;' ${isNumber ? ` class='right'` : ''}>${value}</div>
                </td>
              </tr>
          `
        }
      }
      htmlStr += ' </table> '
      return htmlStr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderListTop.vue